import loginMp3 from '../../../../audio/notifications/login.mp3';
import loginOgg from '../../../../audio/notifications/login.ogg';
import logoutMp3 from '../../../../audio/notifications/logout.mp3';
import logoutOgg from '../../../../audio/notifications/logout.ogg';
import messageMp3 from '../../../../audio/notifications/message.mp3';
import messageOgg from '../../../../audio/notifications/message.ogg';
import negativeMp3 from '../../../../audio/notifications/negative.mp3';
import negativeOgg from '../../../../audio/notifications/negative.ogg';
import positiveMp3 from '../../../../audio/notifications/positive.mp3';
import positiveOgg from '../../../../audio/notifications/positive.ogg';
import {AudioNotification} from '../../enums/AudioNotification';


export const AudioNotificationSounds = {
  [AudioNotification.login]: {
    mp3: loginMp3,
    ogg: loginOgg,
  },
  [AudioNotification.logout]: {
    mp3: logoutMp3,
    ogg: logoutOgg,
  },
  [AudioNotification.message]: {
    mp3: messageMp3,
    ogg: messageOgg,
  },
  [AudioNotification.negative]: {
    mp3: negativeMp3,
    ogg: negativeOgg,
  },
  [AudioNotification.positive]: {
    mp3: positiveMp3,
    ogg: positiveOgg,
  },
};



// WEBPACK FOOTER //
// ./src/js/core-utilities/notifications/audioNotifications/index.js